import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { Box, Button, Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { preparePageTitle } from '@/Module/Core/Helper';
import { useAppDispatch } from '@/Module/Store/Hook';
import { reverseCouponAction } from '@/Module/Subscription/Store/Action';
interface IThankYouFailedProps {
  orderId?: number;
}
const ThankYouFailed: FC<IThankYouFailedProps> = ({
  orderId
}) => {
  const dispatch = useAppDispatch();
  if (orderId) dispatch(reverseCouponAction({
    orderId
  }));
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="ThankYouFailed.tsx">
        <title>{preparePageTitle('پرداخت ناموفق')}</title>
      </Head>
      <Container className="my-8 max-w-[480px] md:my-20" data-sentry-element="Container" data-sentry-source-file="ThankYouFailed.tsx">
        <Box color="orange" className="border-4 border-blueFive bg-grade-description bg-contain bg-right-bottom bg-no-repeat p-4 md:px-8 md:py-10" data-sentry-element="Box" data-sentry-source-file="ThankYouFailed.tsx">
          <div className="mb-12 flex items-center justify-center">
            <Image src={`${FILE_BROWSER_URL}/img/img-failed.svg`} alt="پرداخت ناموفق" width={281} height={258} data-sentry-element="Image" data-sentry-source-file="ThankYouFailed.tsx" />
          </div>

          <p className="mb-8 text-center text-2xl font-bold text-orange-600">پرداختت ناموفق بود، دوباره تلاش کن.</p>

          <Button href={LINKS.SUBSCRIPTION.MAIN} as={Link} variant="shadow" color="orange" className="w-full" radius="circle" size="large" bold data-sentry-element="Button" data-sentry-source-file="ThankYouFailed.tsx">
            تلاش مجدد
          </Button>
        </Box>
      </Container>
    </>;
};
export default ThankYouFailed;